import type { UiDefaultHookQueryVariables } from "$routes/user/_lib/__generated__/use-ui-default.gql";
import useUiDefault from "$routes/user/_lib/use-ui-default";
import { DefaultScope } from "elephant-web/gql";

export const whatsappConsentUiDefaultVariables: UiDefaultHookQueryVariables["args"] =
  {
    name: "whatsappConsentModal2",
    namespace: "elephant-web",
    scope: DefaultScope.User,
  };

interface Value {
  hasSeen: boolean;
}
export const useExistingUserWhatsappConsentOverlayUiDefaults = ({
  defaultValue,
  onCompleted,
  onError,
}: Omit<
  Parameters<typeof useUiDefault<Value>>[0],
  "name" | "namespace" | "scope"
> = {}) => {
  const { save, ...rest } = useUiDefault<Value>({
    ...whatsappConsentUiDefaultVariables,
    defaultValue,
    onCompleted,
    onError,
  });
  const saveHasSeen = (hasSeen: boolean) => {
    save({ hasSeen });
  };

  return { save: saveHasSeen, ...rest };
};
